import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPrint = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M12.666 5.333H3.333c-1.107 0-2 .894-2 2v4H4V14h8v-2.667h2.666v-4c0-1.106-.893-2-2-2zm-2 7.334H5.333V9.333h5.333v3.334zm2-4.667C12.3 8 12 7.7 12 7.333c0-.366.3-.666.666-.666.367 0 .667.3.667.666 0 .367-.3.667-.667.667zM12 2H4v2.667h8V2z"
	})
});
export default SvgIconPrint;
